// megafooter start
jQuery('.megafooter__btn').on('click', (e) => {
  const megafooter = jQuery('.megafooter');

  if (jQuery(megafooter).hasClass('hidden')) {
    jQuery('.megafooter__open-btn, .megafooter__close-btn').each((index, btn) =>
      jQuery(btn).addClass('open'),
    );
    jQuery(megafooter).removeClass('hidden');
  } else {
    jQuery('.megafooter__open-btn, .megafooter__close-btn').each((index, btn) =>
      jQuery(btn).removeClass('open'),
    );
    jQuery(megafooter).addClass('hidden');
  }
});
// megafooter end
